import moment from 'moment';
import { API_DATE_FORMAT, DD_MM_YYYY, MOMENT_LL } from 'constants/date-format';

export const getInclusiveDates = (d1: Date, d2: Date): string[] => {
  const cloneOfD1 = new Date(d1);
  const cloneOfD2 = new Date(d2);
  cloneOfD1.setHours(0);
  cloneOfD2.setHours(0);

  const dates = [moment(cloneOfD1).format(API_DATE_FORMAT)];
  if (cloneOfD1 === cloneOfD2) return dates;

  do {
    const d = new Date(cloneOfD1.setDate(cloneOfD1.getDate() + 1));
    dates.push(moment(d).format(API_DATE_FORMAT));
  } while (new Date(cloneOfD2) > cloneOfD1);

  return dates;
};

export const getDateBreakdown = (date: Date): string[] => {
  const momentized = moment(date);
  return [
    momentized.format('DD'),
    momentized.format('MMMM'),
    momentized.format('YYYY'),
  ];
};

export const getHumanizedRange = (startDate: Date, endDate: Date): string => {
  const start = getDateBreakdown(startDate);
  const end = getDateBreakdown(endDate);
  const sameMonthYear = start[1] === end[1] && start[2] === end[2];
  return sameMonthYear
    ? `${start[1]} ${start[0]}-${end[0]}, ${start[2]}`
    : `${moment(startDate).format(MOMENT_LL)} - ${moment(endDate).format(
        MOMENT_LL,
      )}`;
};

export const momentFormat = (date?: Date, template = DD_MM_YYYY): string => {
  const safeDate = date ? new Date(date) : new Date();
  return moment(safeDate).format(template);
};

export const convertToDate = (date?: string | Date | null): Date | null => {
  return date && moment(date, API_DATE_FORMAT, true).isValid()
    ? new Date(date)
    : null;
};

export const dateTransform = (_value: Date, originalValue: Date): string => {
  return moment(originalValue, API_DATE_FORMAT, true).isValid()
    ? moment(originalValue).format(API_DATE_FORMAT)
    : '';
};
